import formatText from '@/utils/transcriptReplacements';

export const fixDictation = (originalDictation: string) => {
  let dictation = originalDictation;

  // Punctuation change patterns
  const punctuationCorrections: Array<[RegExp, string]> = [
    [/[\W]{0,2}punktum[\W]?[ ]*/giu, '. '],
    [/[\W]{0,1}ny[e]? linje[\W]{0,2}/giu, '\n'],
    [/[\W]{0,1}ny[e]? afsnit[\W]{0,2}/giu, '\n\n'],
    [/[\W]{0,1}ny[t]? afsnit[\W]{0,2}/giu, '\n\n'],
    [/[\W]{0,1}naeste linje[\W]{0,2}/giu, '\n'],
    [/[\W]{0,2}skråstreg[\W]?/giu, '/'],
    [/[\W]{0,2}kolon[\W]?/giu, ': '],
    [/[\W]{0,2}komma[\W]?/giu, ', '],
    // open and close parenthesis commands to convert natural language to actual parenthesis "e.g. open parenthesis, close parenthesis" but in Danish
    [/[\W]{0,2}åbn parentes[\W]?/giu, '('],
    [/[\W]{0,2}luk parentes[\W]?/giu, ')'],
  ];

  // Apply the punctuation corrections
  for (const [pattern, replacement] of punctuationCorrections) {
    dictation = dictation.replace(pattern, replacement);
  }

  // Unless the dictation ends with a whitespace, add a space at the end
  if (!/\s$/.test(dictation)) {
    dictation += '&#x20;';
  }

  // Hackly short term fix to prevent weird mis-transcriptions
  // replace the acronym AFSL with ACL
  dictation = dictation.replace(/AFSL/g, 'ACL');
  // replace det vil sige with Dvs
  dictation = dictation.replace(/det vil sige/g, 'dvs.');

  dictation = formatText(dictation);

  return dictation;
};
